<template>
  <section class="home">
    <zm-banner></zm-banner>
    <article class="article">
      <h1 class="article-title">数据报告—为企业提供专业的个性化方案定制信息服务</h1>
      <section class="article-inner">
        <template v-for="(item, index) in reportsList">
          <div class="article-item" :key="index">
            <router-link to="/login">
              <div class="article-item-cover">{{item.title}}</div>
              <h2 class="article-item-title">{{item.title}}</h2>
              <p class="article-item-desc">{{item.desc}}</p>
            </router-link>
          </div>
        </template>
      </section>
    </article>
  </section>
</template>

<script>
import zmBanner  from '@/components/Banner.vue'
export default {
  components: {
    zmBanner
  },
  data () {
    return {
      reportsList: [{
        title: '2019上半年微信小程序市场研究报告',
        desc: '《2019上半年微信小程序市场研究报告》通过对小程序的概念解析和功能分析，对目前的行业发展趋势进行总结，对表现突出的小程序进行画像分析。旨在得出微信小程序发展的一些规律和特点，协助企业了解行业发展状况......'
      }, {
        title: '2019年Q2中国互联网流量季度分析报告',
        desc: '《2019年Q2中国互联网流量季度分析报告》首先从市场发展概览、行业发展情况角度梳理2019年Q2中国PC互联网发展概况；其次从市场发展概览、移动渠道市场、新势力市场的发展、热门行业分析以及......'
      }, {
        title: '2019年中国在线旅游平台用户洞察研究报告',
        desc: '《2019年中国在线旅游平台用户洞察研究报告》是利用定量研究方法，对在线旅游平台用户的出游行为、预订习惯、消费行为等方面进行在线调查及研究，从而帮助了解整体旅游用户群体特征及人群画像，分析.......'
      }, {
        title: '2019年中国游戏直播行业研究报告',
        desc: '2019年游戏直播行业发展进入成熟期，平台间的竞争与离场给市场带来新活力；头部平台收入的迅速增长有效带动整体游戏直播市场规模增长；行业更加规范，整体行业向着良性竞争方向发展。而为拓展更大的市场......'
      }]
    }
  }
}
</script>
<style scoped>
.article {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 130px; 
}
.article-title {
  font-size: 24px;
  text-align: center;
}
.article-inner {
  padding: 65px 88px;
  font-size: 18px;
  overflow: hidden;
}
.article-item {
  width: 244px;
  float: left;
  margin-right: 16px;
}
.article-item:nth-child(4n) {
  margin-right: 0;
}
.article-item-cover {
  width: 245px;
  height: 170px;
  padding: 60px 12px;
  text-align: center;
  color: #fff;
  background-image: url('../assets/cardBg.png');
}
.article-item-title {
  width: 100%;
  margin: 20px auto;
  text-align: center;
  color: #222;
}
.article-item-desc {
  font-size: 14px;
  line-height: 30px;
  color: #444;
}
.article-item-remark {
  color: #444;
  font-size: 12px;
  margin-top: 20px;
}
</style>